export default "__VITE_ASSET__5FINUeT8__"